// @unocss-include
var _a, _b;
import { useCallback, useEffect } from 'react';
import { useResolvedColorMode } from '../colorMode.js';
let defaultColor = '#ffffff';
if (typeof document !== 'undefined') {
    defaultColor =
        (_b = (_a = document.querySelector('meta[name=theme-color]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : defaultColor;
}
function changeThemeColor(color) {
    // evaluate css var if necessary
    if (color.startsWith('var(')) {
        const root = document.documentElement;
        const cssVar = color.slice(4, -1).trim();
        color = getComputedStyle(root).getPropertyValue(cssVar);
    }
    var metaThemeColor = document.querySelector('meta[name=theme-color]');
    if (!metaThemeColor) {
        metaThemeColor = document.createElement('meta');
        metaThemeColor.setAttribute('name', 'theme-color');
        document.head.appendChild(metaThemeColor);
    }
    metaThemeColor === null || metaThemeColor === void 0 ? void 0 : metaThemeColor.setAttribute('content', color);
    console.log('set title bar color', color);
}
export function useTitleBarColor(color) {
    const colorMode = useResolvedColorMode();
    useEffect(() => {
        var _a, _b;
        const finalColor = typeof color === 'string'
            ? color
            : colorMode === 'dark'
                ? color.dark
                : color.light;
        const previousColor = (_b = (_a = document
            .querySelector('meta[name=theme-color]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : defaultColor;
        changeThemeColor(finalColor);
        return () => {
            changeThemeColor(previousColor);
        };
    }, [color, colorMode]);
}
export function useSetTitleBarColor() {
    const setColor = useCallback((color) => changeThemeColor(color), []);
    const resetColor = useCallback(() => changeThemeColor(defaultColor), []);
    return { setColor, resetColor };
}
//# sourceMappingURL=useTitleBarColor.js.map